import type { ModuleFederationRuntimePlugin } from '@module-federation/runtime';

const describeError = (error: unknown) =>
  error instanceof Error ? `${error.name}: ${error.message}\n${error.stack ?? ''}` : String(error);

const mfFallbackPlugin: () => ModuleFederationRuntimePlugin = () => ({
  name: 'msp-fallback-plugin',

  errorLoadRemote(args) {
    Promise.resolve(args.error).then(
      (error) => console.debug('[MF] errorLoadRemote caught:', args.id, args.lifecycle, describeError(error)),
      (error) => console.debug('[MF] errorLoadRemote caught:', args.id, args.lifecycle, describeError(error)),
    );

    if (args.lifecycle === 'afterResolve') {
      return {
        id: 'msp:fallback',
        name: 'msp',
        metaData: {
          name: 'msp',
          type: 'app',
          buildInfo: { buildVersion: '0.0.0', buildName: 'msp' },
          remoteEntry: { name: 'remoteEntry.js', path: '', type: 'module' },
          types: { path: '', name: '', zip: '@mf-types.zip', api: '@mf-types.d.ts' },
          globalName: 'msp',
          pluginVersion: '0.0.0',
          publicPath: '',
        },
        shared: [],
        exposes: [],
        remotes: [],
      };
    }

    return null;
  },
});

export default mfFallbackPlugin;
